export default [
    {
        path: '/budget-plan',
        name: 'PageBudgetPlanList',
        meta: { title: 'budgetPlan.listTitle', roles: ['ADMIN', 'TEAM_LEADER'], permissions: ['budget_report_view'] },
        component: () => import('@/pages/budget-plan'),
    },
]